
import { bulkParticipantManagementEnabled, dataExportsEnabled, goalLibraryEnabled } from "./features";

const getParticipantOptions = (id?: string) => {
    if (!id) {
        return [];
    }

    const options = [
        {
            text: 'Profile',
            href: `/participants/${id}/profile-demographics`
        },
        {
            text: 'Notes Feed',
            href: `/participants/${id}/notes`
        },
        {
            text: 'Programs',
            href: `/participants/${id}/programs`
        },
        {
            text: 'Tracking',
            href: `/participants/${id}/tracking`
        }
    ];

    options.push({
        text: 'Plans',
        href: `/participants/${id}/plans`
    });

    return options;
};

const getLockedDownAdminOptions = () => {
    const options = [
        {
            text: 'Users',
            href: '/admin/users'
        },
        {
            text: 'Organization',
            href: '/admin/organization'
        },
        {
            text: 'Billing',
            href: '/admin/billing'
        },
        {
            text: 'Usage',
            href: '/admin/usage'
        },
        {
            text: 'Terms of Service',
            href: '/admin/tos'
        }
    ];

    if (dataExportsEnabled) {
        options.splice(options.length - 1, 0, {
            text: 'Data Exports',
            href: '/admin/data-exports'
        });
    }

    return options;
};

const getAdminOptions = () => {
    const options = [];

    options.push(...[
        
        {
            text: 'Forms',
            href: '/admin/forms'
        },
        {
            text: 'Users',
            href: '/admin/users'
        },
        {
            text: 'Programs',
            href: '/admin/programs'
        },
        {
            text: 'Organization',
            href: '/admin/organization'
        },
        {
            text: 'Billing',
            href: '/admin/billing'
        },
        {
            text: 'Usage',
            href: '/admin/usage'
        },
        {
            text: 'Terms of Service',
            href: '/admin/tos'
        }
    ]);

    if (goalLibraryEnabled) {
        options.splice(3, 0, { text: 'Goals Library', href: '/admin/goals-library' });
    }

    if (dataExportsEnabled) {
        options.splice(options.length - 1, 0, {
            text: 'Data Exports',
            href: '/admin/data-exports'
        });
    }

    return options;
};

const getTrackingOptions = (onClick: () => void) => {
    return [
        {
            text: 'Outputs and Outcomes',
            href: '/tracking/delivery',
            onClick
        },
        {
            text: 'Assessments',
            href: '/tracking/assessments',
            onClick
        }
    ];
};

const getReportsOptions = () => {
    const options = [
        {
            text: 'Demographics',
            href: '/reports/demographics'
        },
        {
            text: 'Outputs and Outcomes',
            href: '/reports/outputs'
        }
    ];

    options.push({
        text: 'Plans',
        href: '/reports/plans'
    });

    return options;
};

const getExportOptions = () => {
    const options = [
        {
            text: 'Demographics',
            href: '/exports/demographics'
        },
        {
            text: 'Outputs and Outcomes',
            href: '/exports/outputs'
        },
        {
            text: 'Assessments',
            href: '/exports/assessments'
        }
    ];

    options.push({
        text: 'Plans',
        href: '/exports/plans'
    });

    return options;
};

const getLandingPageOptions = (
    totalDuplicates?: string,
    totalPublicSubmissions?: string,
    publicFormsEnabled?: boolean,
    isFreePlan?: boolean,
    onPublicFormsPaywall?: () => void,
    participantDataImportEnabled?: boolean
) => {
    const options = [];

    options.push({
        text: 'Add Participant',
        href: '/participants/add'
    });

    if (participantDataImportEnabled) {
        options.push({
            text: 'Import Data',
            href: '/import'
        });
    }

    if (bulkParticipantManagementEnabled) {
        options.push({
            text: 'Inactive Participants',
            href: '/bulk-management/participants'
        });
    }

    if (publicFormsEnabled) {
        options.push({
            text: 'Public Submissions',
            subText: isFreePlan ? '(Paid)' : undefined,
            href: isFreePlan ? undefined : '/submissions/public',
            onClick: isFreePlan ? onPublicFormsPaywall : undefined,
            badge: isFreePlan ? undefined : totalPublicSubmissions
        });
    }

    options.push({
        text: 'Duplicate Participants',
        href: '/participants/duplicates',
        badge: totalDuplicates
    });

    return options;
};

export {
    getParticipantOptions,
    getTrackingOptions,
    getReportsOptions,
    getAdminOptions,
    getExportOptions,
    getLockedDownAdminOptions,
    getLandingPageOptions
}
